<template>
  <div>
    <app-title>
      Call Log
      <v-btn color="success" @click="$router.go(-1)">Back</v-btn>
    </app-title>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" label="Filter" single-line hide-details></v-text-field>
      </v-card-title>

      <v-card-text>
        <v-data-table :headers="headers" :items="logs" :search="search" item-key="date">
          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="5">
                <b>{{props.item['date'].toLocaleDateString()}}</b>
              </td>
            </tr>

            <tr v-for="(call,callIndex) in props.item.calls" :key="callIndex" :class="'ma-0'">
              <td :class="'text-xs-center'">{{convertToDate(call['start'])}}</td>
              <td :class="'text-xs-center'">{{getUser(call['from'])}}</td>
              <td :class="'text-xs-center'">{{getUser(call['to'])}}</td>
              <td :class="'text-xs-center'">{{getDuration(call["end"] - call["start"])}}</td>
            </tr>
            <!-- <td v-for="(prop,propIndex) in headers" :key="propIndex" :class="'ma-0'">
            <div v-if="isDateColumn(prop.value)">{{convertToDate(props.item[prop.value])}}</div>
            <div
              v-else-if="prop.text == 'To' || prop.text == 'From'"
            >{{getUser(props.item[prop.value])}})</div>
            <div v-else-if="prop.text == 'Duration'">{{getDuration(props)}}</div>
            <div v-else :class="'text-xs-' + prop.align">{{props.item[prop.value]}}</div>
            </td>-->
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">There are no calls recorded</v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      pagination: {
        sortBy: "start"
      },
      logs: [
        {
          date: new Date("10/04/2019"),
          calls: [
            {
              id: 1624923,
              call_id: "5fc4-ff4-452019233133-bn02-nsy1-0-202.169.183.67",
              domain: 324,
              from: "<sip:61291592950@account.70.vonex.biz>",
              to: '"Joe Bloggs" <sip:61291600994@account.70.vonex.biz>',
              start: "1557099095.612",
              connect: "1557099095.613",
              end: "1557099098.682",
              pcap: false,
              extensions: [],
              trunks: [103]
            },
            {
              id: 1624923,
              call_id: "5fc4-ff4-452019233133-bn02-nsy1-0-202.169.183.67",
              domain: 324,
              from: "<sip:2323838377@account.70.vonex.biz>",
              to:
                '"Joe Bloggs The Second" <sip:239433445@account.70.vonex.biz>',
              start: "1557099095.612",
              connect: "1557099095.613",
              end: "1557099698.682",
              pcap: false,
              extensions: [],
              trunks: [103]
            }
          ]
        },
        {
          date: new Date("04/05/2019"),
          calls: [
            {
              id: 1524963,
              call_id: "5fc4-ff4-452019233133-bn02-nsy1-0-202.169.183.67",
              domain: 324,
              from: "<sip:2342345677@account.70.vonex.biz>",
              to: '"Joe Bloggs" <sip:1894234765@account.70.vonex.biz>',
              start: "1657099095.612",
              connect: "1557099095.613",
              end: "1657099198.682",
              pcap: false,
              extensions: [],
              trunks: [103]
            }
          ]
        }
      ],

      headers: [
        {
          text: "Start",
          align: "center",
          sortable: true,
          value: "start"
        },
        {
          text: "From",
          align: "center",
          sortable: true,
          value: "from"
        },
        {
          text: "To",
          align: "center",
          sortable: true,
          value: "to"
        },
        {
          text: "Duration",
          align: "center",
          sortable: true,
          value: "connect"
        }
      ]
    };
  },
  computed: {},
  methods: {
    convertToDate(val) {
      let dateVal = new Date(parseFloat(val));
      return dateVal.toLocaleTimeString();
    },
    getDurationInMinutes(val) {
      return val / 60;
    },
    getUser(text) {
      let userName = text.substring(
        text.indexOf('"') + 1,
        text.lastIndexOf('"')
      );
      let number = text.substring(text.indexOf(":") + 1, text.indexOf("@"));

      if (userName) return `${userName} (${number})`;
      return number;
    },
    getDuration(number) {
      let millseconds = Number(number);
      return (
        ("0" + Math.floor(millseconds / 3600)).slice(-2) +
        ":" +
        ("0" + Math.floor((millseconds % 3600) / 60)).slice(-2) +
        ":" +
        ("0" + Math.floor((millseconds % 3600) % 60)).slice(-2)
      );
    },
    groupByDate() {
      var dateArr = Object.values(
        list.reduce((result, { date, type, amount }) => {
          // Create new group
          if (!result[date])
            result[date] = {
              date,
              activities: []
            };
          // Append to group
          result[date].activities.push({
            type,
            amount
          });
          return result;
        }, {})
      );
    },
    isDateColumn(name) {
      if (
        name.toLowerCase().includes("date") ||
        name.toLowerCase().includes("start") ||
        name.toLowerCase().includes("end")
      )
        return true;
      return false;
    },
    selectCall(props) {
      props.selected = !props.selected;
    },
    toggleAll() {
      
      if (this.selected.length) this.selected = [];
      else this.selected = this.logs.slice();
    }
  }

  // //[{"id":1624923,
  // "call_id":"5fc4-ff4-452019233133-bn02-nsy1-0-202.169.183.67",
  // "domain":324,
  // "from":"<sip:61291592950@account.70.vonex.biz>",
  // "to":"\"Joe Bloggs\" <sip:61291600994@account.70.vonex.biz>",
  // "start":"1557099095.612",
  // "connect":"1557099095.613",
  // "end":"1557099098.682",
  // "pcap":false,
  // "extensions":[],
  // "trunks":[103]}]
};
</script>

<style lang="scss" scoped>
</style>